import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Timestamp } from '@bufbuild/protobuf';
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraButton, SpecraInput } from '@mono/ui-components/ensigns';
import { SpecraFormField, SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { format } from 'date-fns';
import { useState } from 'react';
import { useUpdateRfiSubmissionFacts } from './useRfiWorkspaceHome';
const T = Testids.rfiWorkspace;
/** Edit the submission facts (WRT-06 rail "Submission" → Edit). */ export function RfiSubmissionFactsDialog({ rfiResponseProjectId, facts, open, onOpenChange }) {
    const [formatText, setFormat] = useState(facts.submissionFormat);
    const [due, setDue] = useState(facts.questionsDue ? format(facts.questionsDue, 'yyyy-MM-dd') : '');
    const [pageLimit, setPageLimit] = useState(String(facts.pageLimit || ''));
    const [wordLimit, setWordLimit] = useState(String(facts.wordLimit || ''));
    const [wpp, setWpp] = useState(String(facts.wordsPerPage || 500));
    const save = useUpdateRfiSubmissionFacts(rfiResponseProjectId);
    const wppNum = Number(wpp);
    const wppInvalid = !Number.isFinite(wppNum) || wppNum < 100 || wppNum > 1500;
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        onOpenChange: onOpenChange,
        open: open,
        size: "md",
        testId: T.submissionFactsDialog,
        title: "Submission facts",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-[var(--space-3)]",
            children: [
                /*#__PURE__*/ _jsx(SpecraFormField, {
                    htmlFor: "rfi-facts-format",
                    label: "Format",
                    children: /*#__PURE__*/ _jsx(SpecraInput, {
                        id: "rfi-facts-format",
                        maxLength: 200,
                        onChange: (e)=>setFormat(e.target.value),
                        placeholder: "PDF, 10 pages max",
                        value: formatText
                    })
                }),
                /*#__PURE__*/ _jsx(SpecraFormField, {
                    htmlFor: "rfi-facts-questions-due",
                    label: "Questions due",
                    children: /*#__PURE__*/ _jsx(SpecraInput, {
                        id: "rfi-facts-questions-due",
                        onChange: (e)=>setDue(e.target.value),
                        type: "date",
                        value: due
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-1 gap-[var(--space-3)] sm:grid-cols-3",
                    children: [
                        /*#__PURE__*/ _jsx(SpecraFormField, {
                            htmlFor: "rfi-facts-page-limit",
                            label: "Page limit",
                            children: /*#__PURE__*/ _jsx(SpecraInput, {
                                id: "rfi-facts-page-limit",
                                min: 0,
                                onChange: (e)=>setPageLimit(e.target.value),
                                step: "0.5",
                                type: "number",
                                value: pageLimit
                            })
                        }),
                        /*#__PURE__*/ _jsx(SpecraFormField, {
                            htmlFor: "rfi-facts-word-limit",
                            label: "Word limit",
                            children: /*#__PURE__*/ _jsx(SpecraInput, {
                                id: "rfi-facts-word-limit",
                                min: 0,
                                onChange: (e)=>setWordLimit(e.target.value),
                                type: "number",
                                value: wordLimit
                            })
                        }),
                        /*#__PURE__*/ _jsx(SpecraFormField, {
                            error: wppInvalid ? 'Between 100 and 1500' : undefined,
                            hint: "Used to estimate pages until exact pages are measured. Default 500.",
                            htmlFor: "rfi-facts-wpp",
                            label: "Words per page",
                            children: /*#__PURE__*/ _jsx(SpecraInput, {
                                id: "rfi-facts-wpp",
                                invalid: wppInvalid,
                                max: 1500,
                                min: 100,
                                onChange: (e)=>setWpp(e.target.value),
                                type: "number",
                                value: wpp
                            })
                        })
                    ]
                }),
                save.error ? /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                    tone: "danger",
                    children: save.error.message
                }) : null,
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-end gap-[var(--space-2)]",
                    children: [
                        /*#__PURE__*/ _jsx(SpecraButton, {
                            onClick: ()=>onOpenChange(false),
                            size: "sm",
                            variant: "secondary",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(SpecraButton, {
                            "data-testid": T.submissionFactsSave,
                            disabled: wppInvalid || save.isPending,
                            onClick: ()=>save.mutate({
                                    submissionFormat: formatText.trim(),
                                    questionsDue: due ? Timestamp.fromDate(new Date(`${due}T17:00:00`)) : undefined,
                                    pageLimit: Number(pageLimit) || 0,
                                    wordLimit: Math.trunc(Number(wordLimit) || 0),
                                    wordsPerPage: Math.trunc(wppNum)
                                }, {
                                    onSuccess: ()=>onOpenChange(false)
                                }),
                            size: "sm",
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
}
